import { useMutation, useQueryClient } from 'react-query';

import { PromptTemplateResponseDto } from '../../../../backend/src/prompt-template/dto/prompt-template.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface UpdatePromptTemplateParameters {
  id: string;
  title?: string;
  body?: string;
}

export const useUpdatePromptTemplate = (matterId: string | undefined) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation<PromptTemplateResponseDto, Error, UpdatePromptTemplateParameters>(
    async ({ id, title, body }) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.PATCH,
        data: { title, body },
      });

      const res = await fetch(`${APIBaseChronos}/api/matters/${matterId}/prompt-template/${id}`, fetchConfig);

      if (!res.ok) throw new Error('Updating prompt template failed');
      return res.json();
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QueryEntity.PromptTemplates, { matterId }]);
      },
    },
  );
};
